import { render, staticRenderFns } from "./PromoterRanking.vue?vue&type=template&id=44dd0170"
import script from "./PromoterRanking.vue?vue&type=script&lang=js"
export * from "./PromoterRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports